export default __webpack_public_path__ + "static/media/sentiment-card-edit.995d510b.jpg";